import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const YogaStudio = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my yoga studio business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps yoga studio businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for yoga studio businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most yoga studio businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my yoga studio business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like yoga studio. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Yoga Studio - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Yoga Studio CRM", url: "/industries/yoga-studio" }
  ];

  const industryData = {
    name: 'Yoga Studio',
    title: 'Fill Classes Consistently & Reduce Member Churn',
    subtitle: 'Automate class reminders, re-engage inactive members, and grow your membership base on autopilot',
    icon: '🧘',
    challenges: [
      'Classes don\'t fill consistently',
      'Members stop coming without notice',
      'Hard to bring back inactive members',
      'New member onboarding is manual',
      'Workshop enrollment is low'
    ],
    solutions: [
      'Automated class reminder and booking',
      'Inactive member re-engagement',
      'Win-back campaigns',
      'New member onboarding sequences',
      'Workshop promotion automation'
    ],
    features: [
      'Member CRM with attendance tracking',
      'Class booking automation',
      'Attendance monitoring',
      'Re-engagement campaigns',
      'New member onboarding',
      'Workshop management',
      'Package and membership tracking',
      'Review automation'
    ],
    results: [
      '85% average class capacity',
      '40% reduction in churn',
      '60% more workshop attendance',
      '£3.7K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Yoga Studio UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for yoga studio businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for yoga studio UK, yoga studio business software, yoga studio customer management, yoga studio lead generation UK"
        url="/industries/yoga-studio"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default YogaStudio;